var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_558_1644)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.39075 10.5689V6.07943C7.98452 6.82938 9.21887 7.55384 10.6788 8.3349C9.47467 9.00267 7.98452 9.75193 6.39075 10.5689ZM15.2728 3.84662C14.9979 3.48441 14.5293 3.20246 14.0305 3.10912C12.5642 2.83068 3.41679 2.82989 1.95132 3.10912C1.55129 3.18411 1.19507 3.36538 0.889066 3.64701C-0.40029 4.84373 0.00373294 11.2614 0.314518 12.3009C0.445206 12.7509 0.614152 13.0754 0.82692 13.2884C1.10105 13.57 1.47637 13.764 1.90749 13.8509C3.11476 14.1006 9.33443 14.2403 14.005 13.8884C14.4353 13.8134 14.8162 13.6133 15.1166 13.3197C16.3087 12.1277 16.2275 5.3497 15.2728 3.84662Z",
    fill: "#FBFBFB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_558_1644"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.2198cb8539944d35aae0ec19f2e09e63.svg";
export { ForwardRef as ReactComponent };